// Upcoming / past split for the activities lists.
//
// Event dates are stored as ISO "YYYY-MM-DD" on src/api/events.js. Comparing
// ISO strings is enough (lexicographic == chronological) and avoids timezone
// drift; "today" is resolved in Africa/Casablanca so a Moroccan visitor never
// sees an event flip a day early or late.

export const EVENT_TIME_ZONE = "Africa/Casablanca";

export function todayISO(timeZone = EVENT_TIME_ZONE) {
  // en-CA formats as YYYY-MM-DD.
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

// An event is over once its last day has passed. Events without dates are kept
// in "upcoming" rather than silently archived.
const lastDay = (event) => event.endDate || event.startDate || "";
const firstDay = (event) => event.startDate || event.endDate || "";

export function isUpcoming(event, today = todayISO()) {
  const end = lastDay(event);
  return !end || end >= today;
}

export function splitEvents(events = [], today = todayISO()) {
  const upcoming = [];
  const past = [];

  events.forEach((event) => {
    (isUpcoming(event, today) ? upcoming : past).push(event);
  });

  upcoming.sort((a, b) => firstDay(a).localeCompare(firstDay(b)));
  past.sort((a, b) => lastDay(b).localeCompare(lastDay(a))); // most recent first

  return { upcoming, past };
}
